import fetch from 'cross-fetch';

import WpToastManager from 'Wpds/components/toast/WpToastManager';

export const getClientSideSearchData = () => (dispatch, getState) => {
  const clientSideSearchData = getState().clientSideSearchData;
  if (clientSideSearchData.wasRequested) return clientSideSearchData.data;
  if (clientSideSearchData.loading) return [];

  dispatch({
    type: 'REQUEST_CLIENT_SIDE_SEARCH_DATA_RESOURCE',
  });

  return fetch('/api/v0/users/client_side_search', {
    method: 'GET',
  })
    .then(response => response.json())
    .then(json => {
      if (json.error) {
        WpToastManager.danger(json.error);
        return [];
      }

      dispatch({
        type: 'RECEIVE_CLIENT_SIDE_SEARCH_DATA_RESOURCE',
        data: json.data,
      });
      return json.data;
    })
    .catch(() => WpToastManager.danger('Something went wrong on our end. Please try again.'));
};
